/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Badge } from 'react-bootstrap';

import { ComputeEnv, ComputeTarif, ConvSecu } from '../Fonctions';
import { tab_modeles, tab_couleurs, options } from '../Correspondances';

import DisplayImage from './DisplayImage';
import BoutonDevis from './BoutonDevis';

function LeftPanel({ tarifs, HorsNormes, isPortrait, store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, orientation}) {
	let fontSize;
	isPortrait ? fontSize = '80%' : fontSize = '100%';
	
	return (
		<Stack gap={isPortrait ? 0 : 2}>
			{HorsNormes && isPortrait ? null :
			<DisplayImage store_type={store_type} couleur={couleur} commande={commande} isPortrait={isPortrait}/>}
			<Stack gap={isPortrait ? 2 : 3} className="col-md-7 mx-auto">
			{!HorsNormes ?
				<Stack gap={1} className="mx-auto">
					<p style={{ textAlign: 'center', marginBottom: '0%' }}>
					StoreVision {tab_modeles[store_type]} {store_type ? '' : tab_couleurs[couleur]} — {ConvSecu(securite, ComputeEnv(securite, environnement)[0], orientation)[2]} / 20 WE Noir / {ConvSecu(securite, ComputeEnv(securite, environnement)[0], orientation)[1]} — Commande {options[commande]}
					</p>
					<p style={{ textAlign: 'center', marginBottom: '0%' }}>
					Dimensions (largeur x hauteur) : {largeur} x {hauteur} mm
					</p>
					<p style={{ textAlign: 'center', marginBottom: '0%', fontFamily: 'JTMarnieBold' }}>Prix estimé</p>
					<Badge style={isPortrait ? { fontSize: '100%', fontFamily: 'JTMarnieBold' } : { fontSize: '130%', fontFamily: 'JTMarnieBold' }} bg="dark" className='mx-auto'>{ComputeTarif(tarifs, largeur*hauteur/1e6, securite, environnement, store_type, commande, orientation)}€ TTC</Badge>
					<p style={{ textAlign: 'center', margin: 'auto', fontSize: fontSize }}>Supplément à ajouter par rapport à une fenêtre standard.</p>
					<p style={{ textAlign: 'center', margin: 'auto', fontSize: fontSize }}>Pose et menuiserie non incluses.</p>
				</Stack> :
				<p style={{ textAlign: 'center', fontFamily: 'JTMarnieBold', marginBottom: '0%', marginTop: '10px' }}>
					📝 Configuration nécessitant une étude.
				</p>
				}
				<BoutonDevis
				isPortrait={isPortrait}
				store_type={store_type}
				commande={commande}
				compas={compas}
				securite={securite}
				largeur={largeur}
				hauteur={hauteur}
				couleur={couleur}
				environnement={environnement}
				HorsNormes={HorsNormes}
				computeenv={ComputeEnv(securite, environnement)[0]}
				prix={ComputeTarif(tarifs, largeur*hauteur/1e6, securite, environnement, store_type, commande, orientation)}
				orientation={orientation}/>
			</Stack>
		</Stack>
	);
}

export default LeftPanel;
